export const DEPRECATION_WARNING = 'DEPRECATION_WARNING'
